import {
    Button,
    ButtonVariant,
    Container,
    ContainerHeader,
} from '@Core/Components'
import { BackButton } from '@Core/Components/BackButton/BackButton'
import { Input, InputSize } from '@Core/Components/Input/Input'
import { MenuOptions } from '@Core/Components/MenuOptions/MenuOptions'
import { IMenuOption } from '@Core/Components/MenuOptions/MenuOptions.types'
import { PermissionWrapper } from '@Core/Components/PermissionWrapper/PermissionWrapper'
import { RightContent } from '@Entry/Common/Header/Header.styles'
import { RoutesPaths } from '@InventoryControl/RoutesPaths'
import { roles } from '@InventoryControl/roles'
import { exportXlsx } from '@Utils/Support/exportXlsx'
import { useEffect, useState } from 'react'
import { TfiExport } from 'react-icons/tfi'
import { useNavigate } from 'react-router-dom'
import { ExitList } from '../Common/Components/ExitList/ExitList'
import { useInventoryExits } from '../Hooks/useInventoryExits/useInventoryExits'
import {
    exportExitData,
    exportInventoryDictionary,
    exportInventoryExitValueDictionary,
} from '../Utils/excelExport'

export const ExitsList = () => {
    const { exits, getExits, loading } = useInventoryExits()
    const navigate = useNavigate()
    const [searchText, setSearchText] = useState('')

    const filteredExits = exits.filter(
        (exit) =>
            exit?.product?.name
                ?.toLowerCase()
                .includes(searchText.toLowerCase()) ||
            exit?.destination?.name
                ?.toLowerCase()
                ?.includes(searchText.toLowerCase()) ||
            exit?.client?.corporateName
                ?.toLowerCase()
                ?.includes(searchText.toLowerCase())
    )
    const handleCreate = () => {
        navigate(RoutesPaths.InventoryCreateExit)
    }

    const handleSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value)
    }

    const exportMenuList: IMenuOption[] = [
        {
            label: 'Exportar para Excel',
            onClick: () => {
                exportXlsx(exportExitData(filteredExits), `Saídas`, {
                    columnsDict: exportInventoryDictionary,
                    valuesDict: exportInventoryExitValueDictionary,
                    sheetName: 'Saídas',
                })
            },
        },
    ]

    useEffect(() => {
        getExits()
    }, [])

    return (
        <Container>
            <BackButton />
            <ContainerHeader>
                <h1 className="text-2xl font-bold">Saídas</h1>
                <RightContent>
                    <Input
                        useUnform={false}
                        name="search"
                        size={InputSize.Small}
                        label="Buscar"
                        onChange={handleSearch}
                        value={searchText}
                    />
                    <PermissionWrapper
                        permission={roles.exit.permissions.create.key}
                    >
                        <Button
                            onClick={handleCreate}
                            variant={ButtonVariant.primary}
                            color="primary"
                        >
                            Nova Saída
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper
                        permission={roles.exit.permissions.export.key}
                    >
                        <MenuOptions menuList={exportMenuList}>
                            <TfiExport />
                        </MenuOptions>
                    </PermissionWrapper>
                </RightContent>
            </ContainerHeader>
            <ExitList filteredExits={filteredExits} loading={loading} />
        </Container>
    )
}
